"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var RadioButtonUnchecked_1 = __importDefault(require("@material-ui/icons/RadioButtonUnchecked"));
var CheckCircleOutline_1 = __importDefault(require("@material-ui/icons/CheckCircleOutline"));
var Edit_1 = __importDefault(require("@material-ui/icons/Edit"));
var Clear_1 = __importDefault(require("@material-ui/icons/Clear"));
var core_2 = require("@21st-night/core");
var editor_web_1 = require("@21st-night/editor-web");
var IconButton_1 = __importDefault(require("../../IconButton"));
var RichText_1 = __importDefault(require("../../RichText"));
exports.useStyles = styles_1.makeStyles(function (theme) { return ({
    root: {
        alignItems: 'flex-start',
        backgroundColor: theme.palette.background.default,
        position: 'relative',
        '&:hover $editButtons': {
            display: 'flex',
        },
    },
    backgroundPaper: {
        backgroundColor: theme.palette.background.paper,
    },
    listItemIcon: {
        marginTop: 4,
        minWidth: 36,
    },
    checkbox: {
        color: theme.palette.text.secondary,
        marginLeft: theme.spacing(0.5),
    },
    checkboxChecked: {
        color: '#81C784',
    },
    content: {
        flex: 1,
        marginLeft: theme.spacing(2),
    },
    checked: {
        textDecoration: 'line-through',
        color: theme.palette.text.secondary,
    },
    editButtons: {
        position: 'absolute',
        right: 0,
        top: 0,
        display: 'none',
    },
    tooltip: {
        marginBottom: -14,
    },
}); });
var StudyPlanSubItem = function (_a) {
    var background = _a.background, classNameProp = _a.className, onClickDelete = _a.onClickDelete, onClickEdit = _a.onClickEdit, title = _a.title, done = _a.done, readOnly = _a.readOnly, other = __rest(_a, ["background", "className", "onClickDelete", "onClickEdit", "title", "done", "readOnly"]);
    var classes = exports.useStyles();
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(core_1.ListItem, __assign({ button: !readOnly, disableRipple: true, className: clsx_1.default(classes.root, background === 'paper' && classes.backgroundPaper, classNameProp) }, other),
            react_1.default.createElement(core_1.ListItemIcon, { className: classes.listItemIcon }, done ? (react_1.default.createElement(CheckCircleOutline_1.default, { className: clsx_1.default(classes.checkbox, classes.checkboxChecked) })) : (react_1.default.createElement(RadioButtonUnchecked_1.default, { className: classes.checkbox }))),
            react_1.default.createElement(core_1.ListItemText, { className: clsx_1.default(done && classes.checked) },
                react_1.default.createElement(RichText_1.default, { document: editor_web_1.deserializeDocument(title) })),
            !readOnly && (react_1.default.createElement("div", { className: classes.editButtons },
                react_1.default.createElement(core_1.Tooltip, { title: "Edit", placement: "top", classes: { popper: classes.tooltip } },
                    react_1.default.createElement(IconButton_1.default, { onClick: onClickEdit },
                        react_1.default.createElement(Edit_1.default, null))),
                react_1.default.createElement(core_1.Tooltip, { title: "Delete", placement: "top", classes: { popper: classes.tooltip } },
                    react_1.default.createElement(IconButton_1.default, { onClick: onClickDelete },
                        react_1.default.createElement(Clear_1.default, null))))))));
};
exports.default = react_1.default.memo(StudyPlanSubItem, function (prev, next) {
    return (prev.title === next.title &&
        prev.done === next.done &&
        core_2.compareChildren(prev.children, next.children));
});
//# sourceMappingURL=StudyPlanSubItem.js.map